
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getAccountLog } from '@/api/product/productAccount'
@Component({
  name: 'Server-Log',
  components: {
  }
})

export default class extends Vue {
  private key: any = ''
  private id: any = ''
  private logDataList: any[] = []
  private activeSlide: boolean = false

  private async onloadAccountLog () {
    try {
      let data = {
        id: this.id,
        key: this.key
      }
      await getAccountLog(data).then((res: any) => {
        if (res.log) {
          let reg = new RegExp("\n","g")
          let str = res.log.replace(reg,"<br>")
          this.logDataList.push(str)
        }
      })
    } catch (e) {
      
    }
  }
  wheelScroll(e) {
    e = e || window.event;
    // wheelDelta !== 0 为上下滚动
    if (e.wheelDelta !== 0) {
      this.activeSlide = true;
      // 移除监听
      window.removeEventListener("mousewheel", this.wheelScroll)
    }
  }

  @Watch('logDataList')
  watchArr () {
    let bool = this.isInViewPortOfOne(this.$refs.loading)
    if (bool) {
      this.$nextTick(() => {
        let scrollElem:any = this.$refs.container;
        scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
      });
    }
  }

  isInViewPortOfOne (el) {
    const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    const offsetTop = el.offsetTop
    const element:any = document.querySelector(".container")
    const scrollTop:number = element.scrollTop
    const top = offsetTop - scrollTop
    return top <= viewPortHeight
  }

  mounted () {
    this.key = localStorage.getItem("queryKey")
    this.id = localStorage.getItem("queryId")
    setInterval(() => {
      setTimeout(() => {
        this.onloadAccountLog()
      }, 0)
    }, 3000)
  }

  updated() {
    let div:any = document.getElementsByClassName("container");
    if (div && div.length > 0) {
      // 添加鼠标滚轮滚动监听
      window.addEventListener("mousewheel", this.wheelScroll);

      // 添加区域内点击监听
      // div[0].onmousedown = () => {
      //   this.activeSlide = true;
      //   div[0].onmousedown = null;
      // };
      // if (!this.activeSlide) {
      //   div[0].scrollTop = div[0].scrollHeight;
      // }
    }
  }
}
